<div class="flex gap-2 items-center h-full justify-start flex-wrap" [ngClass]="containerClass()"> 
    @for (option of options(); track option.value) {
    <div class="flex items-start justify-start !min-w-fit" [ngClass]="itemClass()">
        <span class="flex items-center cursor-pointer relative">
            <input type="checkbox" [checked]="isSelected(option.value)"
                class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border bg-white border-slate-300"
                [id]="option.value" (change)="onCheckboxChange($event, option.value)" />
            <span
                class="absolute text-primary-400 opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"
                    stroke="currentColor" stroke-width="1">
                    <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"></path>
                </svg>
            </span>
        </span>
        <label [for]="option.value" class="ml-1 text-white select-none cursor-pointer" [ngClass]="labelClass()">
            {{option.label}} </label>
    </div>
    }
</div>